module.exports = __webpack_public_path__ + "static/img/Home4.9194c8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Home4.png
// module id = wqul
// module chunks = 1